import { AddressAutocompleteInput } from '../../../shared/AddressAutocompleteInput';

import type { VenueCreateForm } from './useVenueCreateForm';
import { Field, fieldStyle, MONO, STATES, SuggestTag } from './venueCreateFields';

/** Street, city, state and ZIP for a new venue. Picking a suggested street
 *  address fills in the rest. */
export function VenueAddressFields({ form }: { form: VenueCreateForm }) {
  const { stage, fields, edit, update, fieldState, fieldError } = form;
  const req = stage === 'active';
  const sugTag = (k: 'addressLine1' | 'city' | 'state' | 'zipCode') =>
    fieldState(k) === 'suggested' ? <SuggestTag /> : undefined;
  return (
    <>
      <Field
        label="Street address"
        required={req}
        error={fieldError('addressLine1')}
        hint={sugTag('addressLine1')}
      >
        <AddressAutocompleteInput
          aria-label="Street address"
          style={fieldStyle(fieldState('addressLine1'))}
          value={fields.addressLine1}
          onChange={(addressLine1) => update({ addressLine1 })}
          onPick={({ addressLine1, city, state, zipCode }) =>
            update({ addressLine1, city, state, zipCode })
          }
          placeholder="Start typing an address"
        />
      </Field>
      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 12 }}>
        <Field label="City" required={req} error={fieldError('city')} hint={sugTag('city')}>
          <input
            style={fieldStyle(fieldState('city'))}
            value={fields.city}
            onChange={edit('city')}
          />
        </Field>
        <Field label="State" required={req} error={fieldError('state')} hint={sugTag('state')}>
          <select
            style={fieldStyle(fieldState('state'))}
            value={fields.state}
            onChange={edit('state')}
          >
            {STATES.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </Field>
      </div>
      <Field label="ZIP" required={req} error={fieldError('zipCode')} hint={sugTag('zipCode')}>
        <input
          style={fieldStyle(fieldState('zipCode'), { maxWidth: 140, fontFamily: MONO })}
          value={fields.zipCode}
          onChange={edit('zipCode')}
        />
      </Field>
    </>
  );
}
